import { normalizeDate, offsetMaxDate, offsetMinDate } from './shared-dos-min-max.function';
import { IDateOfServiceMinMax } from '../types/date-min-max.type';

export function riskAdjustmentDosMinMax(
  start?: string | Date,
  end?: string | Date,
  isDisallowFuture?: boolean,
  isGracePeriod?: boolean
): IDateOfServiceMinMax {
  const today = new Date();
  const startDate = start ? normalizeDate(start) : new Date(today.getFullYear(), 0, 1);
  const endDate = end ? normalizeDate(end) : new Date(today.getFullYear(), 11, 31);

  const min = offsetMinDate(startDate, isGracePeriod);
  const max = offsetMaxDate(!isDisallowFuture || today > endDate ? endDate : today, isGracePeriod);

  return { min, max } as IDateOfServiceMinMax;
}
